export default {
    text: 'adaptive-heading-text',
    textInShort: 'adaptive-heading-text-in-short',
};
//# sourceMappingURL=dataHooks.js.map